module.exports = __webpack_public_path__ + "static/media/bomb-bitcoin-LP.084590b2.png";